<template>
	<section id="tipos-questao">
	<Notification corner="bottom-right" :closed="true" />
	<container pathName="create">
		<div class="buttonAdd" @click="selectTiposHandler({}, 'cadastrar')">ADICIONAR</div>

		<load-content v-if="loadContent && tiposQuestaoList.length === 0" />

		<div class="relatorio" v-if="tiposQuestaoList.length > 0">
			<a @click="exportTree(true)" href="javascript:void(0)">Exportar Tipos</a>
		</div>

		<div id="tipo-questao-list" v-if="!loadContent && tiposQuestaoList.length > 0">
			<div class="table-wrapper">
				<div class="table">
					<table>
						<thead>
							<tr>
								<th>Descrição</th>
								<th>Data de modificação</th>
								<th>Açoes</th>
							</tr>
						</thead>
						<tbody>
							<tr class="fields" v-for="tiposQuestao in tiposQuestaoList" :key="tiposQuestao.id">
								<td><span>{{ tiposQuestao.descricao }}</span></td>
								<td><span>{{ formatDate(tiposQuestao.dtInsert, tiposQuestao.dtUpdate) }}</span></td>
								<td class="acoes">
									<div class="btn-container">
										<span class="copy-id-obj">
											<copiar :button="true" :text="tiposQuestao.id" :hideText="true"></copiar>
										</span>
										<button class="editar acao" @click="selectTiposHandler(tiposQuestao, 'editar')"><i class="fas fa-pen"></i></button>
										<button-remove class="delete" :onClick="() => selectTiposHandler(tiposQuestao, 'excluir')"></button-remove>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<!-- Modal para cadastro/edição -->
			<div class="modal-blackscreen" v-if="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
				<div class="modal">
					<div class="modalLoading" v-if="modalLoading">
						<load-content />
					</div>

					<div class="adicionar">
						<i class="fas fa-plus"></i>
						<p>{{editarTipoQuestao ? 'Atualizar tipo de questão': 'Adicionar tipo de questão' }} </p>
					</div>

					<div class="input-container">
						<label>Digite a descrição: </label>
						<input type="text" v-on:keyup.enter="() => saveOrUpdate()" placeholder="" v-model="tipoQuestaoDados.descricao"/>
					</div>

					<div class="botoes">
						<button-action type="button" :onClick="closeModal" class="xs default" style="margin-right: 10px;">Cancelar</button-action>
						<button-action type="button" :onClick="() => saveOrUpdate()" class="xs blue">{{ editarTipoQuestao  ? 'ATUALIZAR' : 'ADICIONAR'}}</button-action>
					</div>
				</div>
			</div>
			<!-- Final - Modal para cadastro/edição -->

			<!-- Modal para confirmação de exclusão de tipo questão-->
			<Modal v-show="isModalDeleteVisible" @close="() => this.isModalDeleteVisible = !this.isModalDeleteVisible">
				<template v-slot:body>
					<p class="texto">Deseja remover o tipo de questão <strong><i>{{ tipoQuestaoDados.descricao }}</i></strong>?</p>
				</template>

				<template v-slot:footer>
					<button-action type="button" :onClick="() => remove(tipoQuestaoDados.id)" class="xs danger" style="margin-right: 10px;">Confirmar</button-action>
					<button-action type="button" :onClick="closeModal" class="xs default">Cancelar</button-action>
				</template>
			</Modal>
		<!-- Final exclusão de área de conhecimento  -->
		</div>
	</container>
	</section>
</template>

<script>
import { tipoQuestao as tipoQuestaoService } from '@/services/tipoQuestao'
import ButtonRemove from '@/components/shared/ButtonRemove'
import { formatDateAndTime } from '@/helpers/DateTime'
import Modal from '@/components/shared/Modal'
import ButtonAction from '@/components/shared/ButtonAction'
import container from '@/components/shared/Container'
import LoadContent from '@/components/shared/LoadContent'
import Copiar from '@/components/shared/Copiar'

export default {
	name: 'TipoQuestao',
	components: { container, LoadContent, ButtonAction, Modal, ButtonRemove, Copiar	},
	data () {
		return {
			isModalVisible: false,
			isModalDeleteVisible: false,
			loadContent: false,
			tiposQuestaoList: [],
			editarTipoQuestao: false,
			modalLoading: false,
			tipoQuestaoDados: {},
			tiposQuestao: {}
		}
	},
	async created () {
		this.startPage()
	},
	methods: {
		async startPage () {
			this.loadContent = true
			try {
				const tiposQuestoes = await tipoQuestaoService.find()
				this.tiposQuestaoList = tiposQuestoes.data
				this.loadContent = false
			} catch (error) {
				this.loadContent = false
			}
		},
		formatDate (dtInsert, dtUpdate) {
			const date = dtUpdate !== '' ? dtUpdate : dtInsert
			return formatDateAndTime(date)
		},
		closeModal () {
			this.isModalDeleteVisible = false
			this.isModalVisible = false
			this.editarTipoQuestao = false
		},
		async remove (id) {
			this.loadContent = true
			this.isModalDeleteVisible = false
			try {
				await tipoQuestaoService.delete(id)
				window.notificationEM.open('', 'Tipo de Questão excluído com sucesso!', 'success')
				this.tiposQuestaoList = this.tiposQuestaoList.filter(tipoQuestao => tipoQuestao.id !== id)
			} catch (error) {
				window.notificationEM.open('', error.response.data.msg, 'error')
			}
			this.loadContent = false
		},
		selectTiposHandler (tiposQuestao, action) {
			switch (action) {
			case 'cadastrar':
				this.tipoQuestaoDados = {}
				this.isModalVisible = true
				this.editarTipoQuestao = false
				break
			case 'editar':
				this.tipoQuestaoDados = tiposQuestao
				this.isModalVisible = true
				this.editarTipoQuestao = true
				break
			case 'excluir':
				this.tipoQuestaoDados = tiposQuestao
				this.isModalDeleteVisible = true
				break
			}
		},
		async saveOrUpdate () {
			const errList = this.validateFields()

			if (!errList) {
				this.loadContent = true
				try {
					if (this.editarTipoQuestao) {
						await tipoQuestaoService.update(this.tipoQuestaoDados.id, this.tipoQuestaoDados)
						this.closeModal()
						window.notificationEM.open('', 'Tipo de Questão atualizado com sucesso!', 'success')
					} else {
						await tipoQuestaoService.createTipoQuestao(this.tipoQuestaoDados)
						this.closeModal()
						window.notificationEM.open('', 'Tipo de Questão cadastrado com sucesso!', 'success')
					}
					this.startPage()
				} catch (error) {
					this.loadContent = false
					window.notificationEM.open('', error.response.data.msg, 'error')
				}
			} else {
				const msg = errList.join('<br />')
				window.notificationEM.open('', msg, 'warning')
			}
		},
		validateFields () {
			const errors = []
			if (this.tipoQuestaoDados.descricao === '' || !this.tipoQuestaoDados.descricao) {
				errors.push('É necessário informar uma descrição para prosseguir.')
			}

			return errors.length ? errors : false
		},
		async exportTree () {
			const reportRequest = await tipoQuestaoService.exportTree()

			window.open(reportRequest.data.arquivo)
		}
	}
}
</script>
<style lang="scss" scoped>
#tipos-questao{
	.relatorio {
		position: relative;
		top: 8px;
		background-color: $inputs-color;
		border-radius: $border-radius;
		text-align: right;

		> a, label {
			position: relative;
			display: inline-block;
			padding: 10px 45px 10px 30px;
			border-radius: 0 $border-radius $border-radius 0;
			font-family: $font-family-alternative;
			background: $success-color;
			color: $inputs-color;
			text-decoration: none;
			font-size: .9em;
			cursor: pointer;

			&:last-child {
				border-radius: 0 $border-radius $border-radius 0;
				margin-right: 0;
			}

			.fas {
				position: absolute;
				right: 0px;
				top: 5px;
				padding: 10px 15px;
			}

			&.reportMenuOpen {
				border-radius: 3px;
			}

			&.relatorio-geral {
				border-radius: 3px;
			}
		}

		> a {
			padding: 10px 45px;
			margin-right: 2px;
			border-radius: 0;
			transition: .167s linear;

			&:hover {
				background-color: $main-color;
			}
		}

		input {
			position: absolute;
			top: 0;
			left: 0;
			pointer-events: none;
			opacity: 0;

			~ ul {
				position: absolute;
				top: 50px;
				right: 0;
				z-index: 1;
				display: none;
				width: 30%;
				grid-template-columns: 1fr;
				padding: 15px 0;
				border-radius: $border-radius;
				box-shadow: 1px 1px 1px #0003;;
				background-color: #2952AB;
				color: $inputs-color;
				font-size: .9em;

				li {
					a {
						display: inline-block;
						width: 100%;
						padding: 10px 32px;
						text-align: center;
						color: inherit;
						text-decoration: inherit;
						transition: background-color .167 linear;

						&:hover {
							background-color: #FFF3;
						}
					}
				}
			}

			&:checked ~ ul {
				display: block;
			}
		}
	}
	.buttonAdd {
		cursor: pointer;
		position: absolute;
		right: 20px;
		margin-bottom: 50px;
		top: 20px;
		padding: 16px 49px 15px 47px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: $success-color;
		border-radius:5px;
		text-decoration: none;
		color:#fff;
		text-transform: uppercase;
		font-family: $font-family;
		font-size: 1em;
		font-weight: $font-weight-buttons;

		&:hover, &:active{
			background-color: $main-color;
			color: #f9fdff;
		}
	}
	.modal-blackscreen {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2;

		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;
		height: 100vh;
		background-color: #0007;

		.modal {
			position: fixed;
			z-index: 1;
			width: 850px;
			min-height: 200px;
			padding: 20px;
			margin: 0 50px auto;
			border-radius: 5px;
			border: 1px solid #707070;
			background-color: #fff;
			color: #000;
			box-shadow: #6667 1px 1px 3px 3px;
			@media only screen and (max-width: 1200px) {
				width: calc(100% - 40px);
			}

			.modalLoading {
				position: absolute;
				display: grid;
				place-items: center;
				width: 100%;
				height: 100%;
				margin: -20px;
				background-color: #0004;
			}

			.adicionar {
				display: flex;
				align-items: center;
				margin-bottom: 15px;

				i {
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: $main-color;
					font-size: 19px;
					height: 30px;
					width: 30px;
					margin-right: 6px;
				}

				p {
					color: $main-color;
					font-weight: bold;
					font-size: 17px;
					text-transform: uppercase;
				}
			}

			.two-columns {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 0 10px;
			}

			.input-container {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 5px 10px;
				margin-top: 10px;
				border-radius: 5px;
				border: 1px solid #70707D;

				label {
					padding: 5px 0;
					margin-right: 10px;
					color: #4F5C6B;
					font-size: 14px;

					.input-tipo-container {
						display: block;
						margin-bottom: -10px;
						font-size: 12px;
						color: #000;
					}
				}

				input {
					flex-grow: 1;
					border: none;
					border-radius: 5px;
				}
			}

			.botoes {
				display: flex;
				align-items: flex-end;
				justify-content: flex-end;
				width: calc(100% + 40px); // 100% + padding left do container + padding-right do container (container => .modal)
				padding: 15px 20px;
				margin: 30px -20px -20px -20px;
				border-radius: 0 0 5px 5px;
				background-color: #F8F9FB;

				button {
					width: unset;
					padding: 12px 40px;
					border: 1px solid #336766;
					text-transform: uppercase;
					font-family: 'Roboto Condensed';
					font-weight: bold;
					font-size: 14px;
					transition: .227s background-color, .227s border-color;

					&:hover {
						background-color: #2951A7;
					}

					&.default {
						padding: 12px 25px;
						border: 1px solid #707070;

						&:hover {
							border-color: #E84949;
							background-color: #E84949;
							color: #FFF;
						}
					}
				}
			}
		}
	}
}

</style>
